import { render, staticRenderFns } from "./video-feature.vue?vue&type=template&id=4bbbf06c"
import script from "./video-feature.vue?vue&type=script&lang=js"
export * from "./video-feature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports